import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolAction } from '@cbridge-packages/symbol';
import { SymbolGroupsAction } from '@cbridge-packages/symbol-groups';

export const reloadSymbolGroupsEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(SymbolAction.remove.done),
  map(() => SymbolGroupsAction.load.started()),
);
